<template>
  <el-dialog
    title="Информация по отправке реестров"
    :visible.sync="visibleModal"
    :width="isMobile ? '90%' : '900px'"
    class="add-registry-dialog"
    append-to-body
    :before-close="handleClose"
    :close-on-click-modal="false"
    @open="getDataBeforeOpen"
  >
    <loader-wrapper :loading="loading">
      <div v-if="logger.length === 0">
        <p class="title">Информации нет. Реестр не был отправлен</p>
      </div>
      <div v-else>
        <el-collapse>
          <el-collapse-item
            v-for="item in logger"
            :key="item.id"
            style="font-family: 'Mulish', sans-serif"
            :title="getDateOfCertainFormat(item.created_at, defaultDateRuFull)"
            :name="item.id"
          >
            <div class="collapse-item">
              <div style="font-weight: bold">
                <p>Отправитель:</p>
              </div>
              <div>
                <p>{{ item.user_fio }}</p>
              </div>
            </div>
            <div class="collapse-item">
              <div style="font-weight: bold">
                <p>Телефон:</p>
              </div>
              <div>
                <p>+{{ item['user_login'] }}</p>
              </div>
            </div>
            <div class="collapse-item">
              <div style="font-weight: bold">
                <p>Тип реестра:</p>
              </div>
              <div>
                <p>{{ getRegistryType(item['template']) }}</p>
              </div>
            </div>
            <div class="collapse-item">
              <div style="font-weight: bold; min-width: 100px">
                <p>Список e-mail:</p>
              </div>
              <div>
                <p v-for="item in getEmailsString(item['emails'])" :key="item">
                  {{ item }}
                </p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDateRu, defaultDateRuFull } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'
import { registryOptions } from '@/components/Shared/constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const registryBidRepository = RepositoryFactory.get('registryBidRepository')

export default {
  name: 'RegistrySentToday',
  components: { LoaderWrapper },
  props: {
    id: { type: Number },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      logger: [],
      activeNames: ['1'],
      registryOptions,
      defaultDateRuFull,
      defaultDateRu,
    }
  },
  computed: {
    visibleModal() {
      return this.visible
    },
  },

  methods: {
    getDateOfCertainFormat,
    getEmailsString(string) {
      let array = string.replace(/, /g, ',').replace(/,/g, ', ').split(' ')
      let prepareArray = []
      let count = 0

      array.map(item => {
        if ((prepareArray[count] + item).length < 105) {
          prepareArray[count] =
            prepareArray[count] !== undefined
              ? prepareArray[count] + ' ' + item + ' '
              : item + ' '
        } else {
          prepareArray.push(item)
          count += 1
        }
      })

      return prepareArray
    },
    getRegistryType(type) {
      return Object.keys(this.registryOptions).includes(type)
        ? this.registryOptions[type].name
        : '-'
    },
    handleClose() {
      this.$emit('close')
    },
    getDataBeforeOpen() {
      registryBidRepository
        .getRegistryEmailLog(this.id)
        .then(response => {
          this.logger = response.data
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style lang="sass">
.add-registry-dialog
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .el-radio
    display: flex
    width: 100%
    margin-right: 0
  .gap-30
    gap: 20px
  .el-form-item__error
    color: #F56C6C
    font-family: 'Mulish', sans-serif
    font-size: 12px
  .title
    font-family: 'Mulish', sans-serif
    font-size: 14px
    font-weight: bold
    color: rgba(0, 0, 0, 0.47)
  .image-slot
    position: relative
    top: 50%
  .registerCard
    padding: 4px
    margin-bottom: 12px
    display: flex
    align-items: center
    justify-content: space-between
  .el-card__body
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
  .label-item
    margin-bottom: 6px
    font-family: 'Mulish', sans-serif
  .collapse-item
    display: flex
    justify-content: space-between
    border: 1px solid #f9f9f9
    padding: 8px 12px
    background: #f8f8f8
    border-radius: 8px
    font-family: 'Mulish', sans-serif
    margin-bottom: 4px
</style>
